const Vue = require('vue')

Vue.component('form-selection', {
    props: {
        query: {
            default () {
                return {}
            }
        },
        selected: {
            default () {
                return []
            }
        },
        except: {
            default () {
                return []
            }
        },
        all: {
            type: Boolean,
            default: false
        },
        store: {
            type: Vue,
            required: true
        }
    },
    data () {
        return {}
    },
    ready () {
    },
    methods: {},
    template: `
<div class="form-selection">
    <slot></slot>
</div>`
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/form/selection.js